import { ai } from '@/api';
import { AiAnalyticsResponse } from '@/types/ai-logs';
import { SortingParamsType } from '@webthatmatters/orca-table';

export type GetAiAnalyticsParams = {
  organizationUuid: string;
  documentKind: string;
  entityType?: string;
  startDate?: string;
  endDate?: string;
  fields?: string[];
  sorting?: SortingParamsType;
};

export const getAiAnalytics = async (params: GetAiAnalyticsParams) => {
  const { organizationUuid, documentKind, entityType, startDate, endDate, fields, sorting } =
    params;

  const queryParams: Record<string, unknown> = {
    start_date: startDate,
    end_date: endDate
  };

  if (entityType) {
    queryParams.entity_type = entityType;
  }

  // Add field filters if provided
  if (fields && fields.length > 0) {
    queryParams.fields = fields;
  }

  // Add sorting if provided
  queryParams.sort_by = Object.keys(sorting ?? {})[0];
  queryParams.sorting = Object.values(sorting ?? {})[0];

  const response = await ai.get<AiAnalyticsResponse>(
    `/documents/analytics/${organizationUuid}/${documentKind}`,
    queryParams
  );

  return response.data;
};
